export const translateTransactionSearch = ({
  token,
  query,
  agencyContext,
  timezone,
}) => ({
  HTTPMethod: "post",
  path: `/transaction-search/translate`,
  queryParams: {},
  body: {
    query,
    agencyContext: agencyContext || [],
    ...(timezone ? { timezone } : {}),
  },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
